import { render, staticRenderFns } from "./TerminalStamp.vue?vue&type=template&id=cf360d50&scoped=true"
import script from "./TerminalStamp.vue?vue&type=script&lang=js"
export * from "./TerminalStamp.vue?vue&type=script&lang=js"
import style0 from "./TerminalStamp.vue?vue&type=style&index=0&id=cf360d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf360d50",
  null
  
)

export default component.exports